import { OtoIndividualTransferPersonInput } from '../../lib/types/models/enrollment/oto-individual-enrollments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateOtoIndividualTransferPerson({
  enrollmentId,
  ...data
}: OtoIndividualTransferPersonInput & { enrollmentId: number }) {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.updateOtoIndividualTransferPerson.url, { id: enrollmentId })
    )
    .patch<unknown, OtoIndividualTransferPersonInput>(data)
}
